<soft-icon [name]="value"></soft-icon>
